/**
 * Returns UTC ISO strings for a "last N days" range anchored to local calendar days.
 *
 * from = 00:00:00.000 local time, (days - 1) days ago
 * to   = 23:59:59.999 local time, today
 *
 * Example: days=7 on 2026-06-16 at 14:30 IST →
 *   from = "2026-06-10T00:00:00.000+05:30" → UTC "2026-06-09T18:30:00.000Z"
 *   to   = "2026-06-16T23:59:59.999+05:30" → UTC "2026-06-16T18:29:59.999Z"
 */
export function lastNDaysRange(days) {
  return lastNDaysRangeFrom(days, null);
}

/**
 * Same as lastNDaysRange but anchors the "to" end at `anchorIso` instead of now.
 * Falls back to now when anchorIso is null/undefined/invalid.
 */
export function lastNDaysRangeFrom(days, anchorIso) {
  const anchor = anchorIso ? new Date(anchorIso) : new Date();
  const effective = Number.isNaN(anchor.getTime()) ? new Date() : anchor;

  const to = new Date(effective);
  to.setHours(23, 59, 59, 999);

  const from = new Date(effective);
  from.setDate(from.getDate() - (days - 1));
  from.setHours(0, 0, 0, 0);

  return { from: from.toISOString(), to: to.toISOString() };
}
